import React from 'react';
import CollectionCard from '../Collections/CollectionCard';
import CollectionListsDropZone from './CollectionListsDropZone';

/**
 * Collections section in MyLists
 * Uses move up/down buttons for reordering instead of drag-and-drop
 */
function CollectionsDropZone({
  collections,
  isReorderMode,
  expandedCollectionId,
  getListsForCollection,
  onCollectionDrop,
  onCollectionListDrop,
  onCollectionClick,
  onCollectionEdit,
  onListClick,
}) {
  const handleMoveUp = (e, index) => {
    e.stopPropagation();
    if (index > 0) {
      onCollectionDrop(collections[index].id, index - 1);
    }
  };

  const handleMoveDown = (e, index) => {
    e.stopPropagation();
    if (index < collections.length - 1) {
      onCollectionDrop(collections[index].id, index + 1);
    }
  };

  return (
    <div className="collections-drop-zone">
      {collections.map((collection, index) => {
        const isExpanded = expandedCollectionId === collection.id;
        const collectionLists = getListsForCollection(collection.listIds);

        return (
          <React.Fragment key={collection.id}>
            <div
              className={`collection-drag-wrapper ${isExpanded ? 'expanded' : ''}`}
              data-collection-id={collection.id}
            >
              {/* Reorder controls */}
              {isReorderMode && (
                <div className="collection-reorder-controls">
                  <button
                    className="reorder-btn reorder-btn-up"
                    onClick={(e) => handleMoveUp(e, index)}
                    disabled={index === 0}
                    aria-label="Move collection up"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                      <polyline points="18 15 12 9 6 15" />
                    </svg>
                  </button>
                  <button
                    className="reorder-btn reorder-btn-down"
                    onClick={(e) => handleMoveDown(e, index)}
                    disabled={index === collections.length - 1}
                    aria-label="Move collection down"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </button>
                </div>
              )}

              <CollectionCard
                collection={collection}
                lists={collectionLists}
                onClick={() => onCollectionClick(collection)}
                onEdit={() => onCollectionEdit(collection)}
                isExpanded={isExpanded}
                isReorderMode={isReorderMode}
              />

              {/* Mobile only: Expanded lists appear below collection (accordion style) */}
              {isExpanded && (
                <div className="collection-expanded-mobile">
                  <div className="collection-expanded-lists-container">
                    <CollectionListsDropZone
                      collectionId={collection.id}
                      lists={collectionLists}
                      listIds={collection.listIds || []}
                      isReorderMode={isReorderMode}
                      onDrop={onCollectionListDrop}
                      onListClick={onListClick}
                      onEditCollection={() => onCollectionEdit(collection)}
                      className="collection-expanded-lists"
                    />
                  </div>
                </div>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default CollectionsDropZone;
